module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Light-Italic.48890510.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Light-Italic.woff
// module id = 3603
// module chunks = 70